import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, Heart } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="relative overflow-hidden bg-nosh-green text-nosh-cream">
    <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-20">
      <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-full border-2 border-nosh-gold font-display text-xl font-bold text-nosh-gold">
              N
            </span>
            <div className="leading-none">
              <div className="font-display text-3xl font-bold">Nosh</div>
              <div className="font-poster text-[9px] font-bold uppercase tracking-[0.42em] text-nosh-gold">Catering</div>
            </div>
          </div>
          <p className="mt-6 max-w-sm font-body text-base leading-relaxed text-nosh-cream/75">
            Home-style desi catering from the kitchen of Harris &amp; Kanwal — recipes passed down
            through generations, cooked with the kind of love you can taste.
          </p>
          <p className="mt-6 font-script text-3xl text-nosh-gold">Nosh — farmaiye!</p>
        </div>

        <div>
          <h4 className="font-poster text-xs font-bold uppercase tracking-[0.25em] text-nosh-gold">Explore</h4>
          <ul className="mt-5 space-y-3 font-body">
            <li><Link to="/" className="text-nosh-cream/80 transition-colors hover:text-nosh-gold">Home</Link></li>
            <li><Link to="/menu" className="text-nosh-cream/80 transition-colors hover:text-nosh-gold">Full Menu</Link></li>
            <li><Link to="/menu#builder" className="text-nosh-cream/80 transition-colors hover:text-nosh-gold">Build Your Tray</Link></li>
            <li><Link to="/about" className="text-nosh-cream/80 transition-colors hover:text-nosh-gold">Our Story</Link></li>
            <li><Link to="/about#inquiry" className="text-nosh-cream/80 transition-colors hover:text-nosh-gold">Get a Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-poster text-xs font-bold uppercase tracking-[0.25em] text-nosh-gold">Get in touch</h4>
          <ul className="mt-5 space-y-4 font-body">
            <li>
              <a href="tel:2016204376" data-testid="footer-phone" className="flex items-center gap-3 text-nosh-cream/80 transition-colors hover:text-nosh-gold">
                <Phone className="h-4 w-4 shrink-0 text-nosh-gold" /> 201-620-4376
              </a>
            </li>
            <li className="flex items-center gap-3 text-nosh-cream/80">
              <MapPin className="h-4 w-4 shrink-0 text-nosh-gold" /> Serving New Jersey &amp; New York
            </li>
            <li className="flex items-center gap-4 pt-1">
              <a href="#" aria-label="Instagram" className="grid h-10 w-10 place-items-center rounded-full border border-nosh-cream/25 transition-colors hover:border-nosh-gold hover:text-nosh-gold">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Facebook" className="grid h-10 w-10 place-items-center rounded-full border border-nosh-cream/25 transition-colors hover:border-nosh-gold hover:text-nosh-gold">
                <Facebook className="h-5 w-5" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-nosh-cream/15 pt-8 md:flex-row">
        <p className="flex items-center gap-2 font-body text-sm text-nosh-cream/70">
          Thank you for supporting local &amp; desi <Heart className="h-3.5 w-3.5 fill-nosh-gold text-nosh-gold" />
        </p>
        <p className="font-body text-xs text-nosh-cream/45">© {new Date().getFullYear()} Nosh Catering · Made with love by Harris &amp; Kanwal</p>
      </div>
    </div>
  </footer>
);

export default Footer;
